import API from './index';

const api = {
    getUserMenu() {
        return API.authAPI({
            url: '/user-menu/',
            method: 'GET',
        });
    },
};

export default api;
